<template>
  <!-- 控制事件冒泡-->
  <el-button
    v-if="stop"
    ref="ref-button"
    :class="{
      'comman btn-gray': gray,
      'comman btn-green': green,
      'comman btn-red': red,
      'comman btn-blue': blue,
      'comman btn-purple': purple,
      'comman btn-warning': warningBtn,
      'comman btn-all-red': allRed,
    }"
    :size="size"
    :type="type"
    :disabled="disabled"
    :plain="plain"
    @click.stop="handlerClick">
    <font-awesome-iconwarning
      v-if="icon&&!rightIcon"
      :icon="[iconType, icon]" />
    <span class="btn-label">
      <slot></slot>
    </span>
    <font-awesome-icon
      v-if="rightIcon"
      :icon="[iconType, icon]" />
  </el-button>
  <el-button
    v-else
    ref="ref-button"
    :class="{
      'comman btn-gray': gray,
      'comman btn-green': green,
      'comman btn-red': red,
      'comman btn-blue': blue,
      'comman btn-purple': purple,
      'comman btn-warning': warningBtn,
      'comman btn-all-red': allRed,
    }"
    :size="size"
    :type="type"
    :disabled="disabled"
    :plain="plain"
    @click="handlerClick">
    <font-awesome-icon
      v-if="icon&&!rightIcon"
      class="icon"
      :icon="[iconType, icon]" />
    <span class="btn-label">
      <slot></slot>
    </span>
    <font-awesome-icon
      v-if="rightIcon"
      class="icon"
      :icon="[iconType, icon]" />
  </el-button>
</template>
<script>
export default {
  name: 'VButton',
  props: {
    size: {
      type: String,
      default: 'mini'
    },
    type: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: 'fas'
    },
    stop: {
      // 控制事件是否冒泡上傳
      type: Boolean,
      default: false
    },
    green: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean,
      default: false
    },
    blue: {
      type: Boolean,
      default: false
    },
    purple: {
      type: Boolean,
      default: false
    },
    red: {
      type: Boolean,
      default: false
    },
    allRed: {
      type: Boolean,
      default: false
    },
    warningBtn: {
      type: Boolean,
      default: false
    },
    rightIcon:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    handlerClick() {
      this.$emit('click')
    },
    currentClick() {
      this.$refs['ref-button'].$el.click()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-button {
  font-family: inherit;
  .svg-inline--fa + .btn-label {
    margin-left: 5px;
  }
}
.comman{
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  &.btn-gray{
    background: #FAFBFC;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    color: #24292E;
  }

  &.btn-red{
    background: #FAFBFC;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    color: #CB2431;
  }
  &.btn-all-red{
    background: $red;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    color: #fff;
  }
  &.is-disabled{
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
  &.btn-green{
    background: #2EA44F;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
    color: #FFFFFF;
    &.is-disabled{
      border-radius: 6px;
      border: 1px solid rgba(27, 31, 35, 0.10);
      background: #94D3A2;
      box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.10);
      color: rgba(255, 255, 255, 0.80);
    }
    &:hover{
      border-radius: 6px;
      border: 1px solid rgba(27, 31, 35, 0.10);
      background: #94D3A2;
      /* btn/primary/shadow */
      box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.10);
      color: rgba(255, 255, 255, 0.80);
    }
  }
  &.btn-blue{
    background: #FAFBFC;
    border: 1px solid rgba(27, 31, 35, 0.15);
    //box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
    color: $blue;
    &.is-disabled{
      border-radius: 6px;
      border: 1px solid rgba(27, 31, 35, 0.10);
      background: #DBEDFF;
      box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.10);
      color: rgba(255, 255, 255, 0.80);
    }
    &:hover{
      border-radius: 6px;
      border: 1px solid rgba(27, 31, 35, 0.10);
      background: #DBEDFF;
      /* btn/primary/shadow */
      box-shadow: 0px 1px 0px 0px rgba(27, 31, 35, 0.10);
      color: rgba(255, 255, 255, 0.80);
    }
  }
  &.btn-purple{
    background: #8d5de8;
    border: 1px solid rgba(141, 93, 232, 0.15);
    //box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
    color: #fff;
    &.is-disabled{
      border-radius: 6px;
      border: 1px solid rgba(141, 93, 232, 0.10);
      background: rgba(141, 93, 232,0.6);
      box-shadow: 0px 1px 0px 0px rgba(141, 93, 232, 0.10);
      color: rgba(255, 255, 255, 0.80);
    }
    &:hover{
      border-radius: 6px;
      border: 1px solid rgba(141, 93, 232, 0.10);
      background: #8d5de8;
      /* btn/primary/shadow */
      box-shadow: 0px 1px 0px 0px rgba(141, 93, 232, 0.10);
      color: rgba(255, 255, 255, 0.80);
    }
  }
  &.btn-warning{
    background: #E6A23C;
    border: 1px solid rgba(230, 162, 6, 0.15);
    //box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
    color: #fff;
    &.is-disabled{
      border-radius: 6px;
      border: 1px solid rgba(230, 162, 6, 0.10);
      background: rgba(230, 162, 6,0.6);
      box-shadow: 0px 1px 0px 0px rgba(230, 162, 6, 0.10);
      color: rgba(255, 255, 255, 0.80);
    }
    &:hover{
      border-radius: 6px;
      border: 1px solid rgba(230, 162, 6, 0.10);
      background: rgba(230, 162, 6,0.6);
      /* btn/primary/shadow */
      box-shadow: 0px 1px 0px 0px rgba(230, 162, 6, 0.10);
      color: rgba(255, 255, 255, 0.80);
    }
  }
}
</style>
